export default [
	{
		category: 'Exponents and root',
		symbols: [
			{
				value: 'Xⁿ',
				returns: null,
				mode: 'superscript',
				provider: {
					original: '0123456789+-=()iInN',
					replacement: '⁰¹²³⁴⁵⁶⁷⁸⁹⁺⁻⁼⁽⁾ⁱⁱⁿⁿ',
				},
				tooltip: 'Click and type to add superscripts',
				columns: 1,
			},
			{
				value: 'Xᵤ',
				returns: null,
				mode: 'subscript',
				provider: {
					original: '0123456789+-=()aAbBeEoOiIrRuUvVxXyY',
					replacement: '₀₁₂₃₄₅₆₇₈₉₊₋₌₍₎ₐₐᵦᵦₑₑₒₒᵢᵢᵣᵣᵤᵤᵥᵥₓᵪᵧᵧ',
				},
				tooltip: 'Click and type to add subscripts',
				columns: 1,
			},
			{
				value: 'X²',
				returns: 'X²',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'X³',
				returns: 'X³',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'X⁴',
				returns: 'X⁴',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '√',
				returns: '√',
				mode: null,
				tooltip: null,
				columns: 1,
			},
		],
	},
	{
		category: 'Operators',
		symbols: [
			{
				value: '+',
				returns: '+',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '-',
				returns: '-',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '×',
				returns: '×',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '÷',
				returns: '÷',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '/',
				returns: '/',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '±',
				returns: '±',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '∑',
				returns: '∑',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '!',
				returns: '!',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'log()',
				returns: 'log()',
				mode: null,
				tooltip: null,
				columns: 2,
			},
			{
				value: 'ln()',
				returns: 'ln()',
				mode: null,
				tooltip: null,
				columns: 2,
			},
		],
	},
	{
		category: 'Angles',
		symbols: [
			{
				value: 'π',
				returns: 'π',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'º',
				returns: 'º',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '\'',
				returns: '\'',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '\'\'',
				returns: '\'\'',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'sin()',
				returns: 'sin()',
				mode: null,
				tooltip: null,
				columns: 2,
			},
			{
				value: 'cos()',
				returns: 'cos()',
				mode: null,
				tooltip: null,
				columns: 2,
			},
			{
				value: 'tan()',
				returns: 'tan()',
				mode: null,
				tooltip: null,
				columns: 2,
			},
			{
				value: 'sin⁻¹()',
				returns: 'sin⁻¹()',
				mode: null,
				tooltip: null,
				columns: 2,
			},
			{
				value: 'cos⁻¹()',
				returns: 'cos⁻¹()',
				mode: null,
				tooltip: null,
				columns: 2,
			},
			{
				value: 'tan⁻¹()',
				returns: 'tan⁻¹()',
				mode: null,
				tooltip: null,
				columns: 2,
			},
		],
	},
	{
		category: 'Functions',
		symbols: [
			{
				value: '()',
				returns: '()',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '[]',
				returns: '[]',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '{}',
				returns: '{}',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '||',
				returns: '||',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'ƒ’(x)',
				returns: 'ƒ’(x)',
				mode: null,
				tooltip: null,
				columns: 2,
			},
			{
				value: 'ƒ’’(x)',
				returns: 'ƒ’’(x)',
				mode: null,
				tooltip: null,
				columns: 2,
			},
			{
				value: '∫',
				returns: '∫',
				mode: null,
				tooltip: null,
				columns: 1,
			},
		],
	},
	{
		category: 'Equations',
		symbols: [
			{
				value: '=',
				returns: '=',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '≠',
				returns: '≠',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '≤',
				returns: '≤',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '<',
				returns: '<',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '>',
				returns: '>',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: '≥',
				returns: '≥',
				mode: null,
				tooltip: null,
				columns: 1,
			},
		],
	},
	{
		category: 'Others',
		symbols: [
			{
				value: '∞',
				returns: '∞',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'α',
				returns: 'α',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'β',
				returns: 'β',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'δ',
				returns: 'δ',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'ε',
				returns: 'ε',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'θ',
				returns: 'θ',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'ω',
				returns: 'ω',
				mode: null,
				tooltip: null,
				columns: 1,
			},
			{
				value: 'γ',
				returns: 'γ',
				mode: null,
				tooltip: null,
				columns: 1,
			},
		],
	},
]
